import React from "react";
import { t } from "i18next";
import { SVGICONS } from "config";
import { UTILS } from "utils";
import { CustomButton } from "components/Button";

const CheckoutDeliveryArea = ({
  userdeliveryAdress,
  setChangeAddressModal,
}) => {
  return (
    <div
      className="flex items-start gap-3 justify-between rounded-16x px-4 py-3 text-shadow-forge-800"
      style={{ border: "1.5px solid #E5E7EB" }}
    >
      <SVGICONS.LocationIcon className="flex-shrink-0 "  width={20} height={20}/>
      <div className="flex-1">
        <span className="break-all  text-14x w-full break-words block">
          {UTILS.getFormattedAddress(userdeliveryAdress) ??
            t("Select Location")}
        </span>
      </div>
      <CustomButton
        id="delivery-address-change"
        onClick={() => setChangeAddressModal(true)}
        className="w-fit"
        outline
        title={t("Change")}
        style={{
          padding: "0px 5px",
          borderRadius: "8px",
        }}
      />
    </div>
  );
};

export default CheckoutDeliveryArea;
